import { Component } from '@angular/core';

@Component({
  selector: 'lib-common-libs',
  standalone: true,
  imports: [],
  template: `
    <p>
      common-libs works!
    </p>
  `,
  styles: ``
})
export class CommonLibsComponent {

}
